<lib-base-signal-input
  [label]="label()"
  [hint]="helpText()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
>
  <div input class="w-full space-y-3 py-2">
    @if (isMobileView()) {
      <div class="w-full space-y-3">
        @for (row of rows(); track rowKey(row); let rowIndex = $index) {
          <div
            class="overflow-hidden rounded-lg border border-gray-200 bg-white"
          >
            <button
              type="button"
              class="flex w-full items-center justify-between gap-3 bg-gray-50 px-4 py-3 text-left transition-colors hover:bg-gray-100"
              [attr.aria-expanded]="isExpanded(row)"
              [attr.aria-controls]="'number-grid-fields-' + rowIndex"
              [disabled]="disabled() || readonly()"
              (click)="toggleRow(row)"
            >
              <span class="min-w-0 flex-1">
                <span
                  class="block break-words text-sm font-medium text-gray-900"
                >
                  {{ row.display }}
                </span>

                <span class="mt-1 block text-xs text-gray-500">
                  {{ columns().length }}
                  {{ columns().length === 1 ? 'field' : 'fields' }}
                </span>
              </span>

              @if (isExpanded(row)) {
                <svg
                  class="size-5 shrink-0 text-gray-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  aria-hidden="true"
                >
                  <path
                    d="m6 15 6-6 6 6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              } @else {
                <svg
                  class="size-5 shrink-0 text-gray-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  aria-hidden="true"
                >
                  <path
                    d="m6 9 6 6 6-6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </button>

            @if (isExpanded(row)) {
              <div
                [id]="'number-grid-fields-' + rowIndex"
                class="border-t border-gray-200 p-4"
              >
                @if (columns().length > 0) {
                  <div class="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
                    @for (column of columns(); track column.id) {
                      <div class="min-w-0 space-y-1">
                        <label
                          class="block break-words text-sm font-medium text-gray-900"
                        >
                          {{ column.label }}
                        </label>

                        <lib-signal-number-field
                          [label]="''"
                          [placeholder]="
                            'Enter ' + column.label.toLowerCase()
                          "
                          [value]="getValue(row, column.id)"
                          [disabled]="isInteractionBlocked()"
                          [hideSpinButtons]="true"
                          [appearance]="'outline'"
                          (valueChange)="
                            onValueChange(rowIndex, column.id, $event)
                          "
                        />
                      </div>
                    }
                  </div>
                } @else {
                  <p class="text-sm text-gray-500">
                    No columns configured.
                  </p>
                }
              </div>
            }
          </div>
        } @empty {
          <div
            class="rounded-lg border border-gray-200 px-4 py-8 text-center text-sm text-gray-500"
          >
            No items available.
          </div>
        }
      </div>
    } @else {
      <div class="w-full overflow-x-auto rounded-lg border border-gray-200">
        <table class="w-full min-w-[420px] table-fixed border-collapse text-sm">
          <thead class="bg-slate-100">
            <tr>
              <th
                class="w-[42%] border-b border-r border-gray-200 px-4 py-3 text-left font-semibold text-gray-700"
              ></th>

              @for (column of columns(); track column.id) {
                <th
                  class="border-b border-r border-gray-200 px-3 py-3 text-center font-semibold text-gray-700 last:border-r-0"
                >
                  {{ column.label }}
                </th>
              }
            </tr>
          </thead>

          <tbody>
            @for (row of rows(); track rowKey(row); let rowIndex = $index) {
              <tr class="border-b border-gray-100 last:border-b-0">
                <td
                  class="border-r border-gray-200 px-4 py-3 font-medium text-gray-900"
                >
                  {{ row.display }}
                </td>
                @for (column of columns(); track column.id; let last = $last) {
                  <td
                    class="border-r border-gray-200 px-3 py-2"
                    [class.border-r-0]="last">
                    <div class="mx-auto w-full max-w-[7.5rem]">
                      <lib-signal-number-field
                        [label]="''"
                        [size]="'sm'"
                        [placeholder]="'0'"
                        [value]="getValue(row, column.id)"
                        [disabled]="isInteractionBlocked()"
                        [hideSpinButtons]="false"
                        [appearance]="'outline'"
                        (valueChange)="
                    onValueChange(rowIndex, column.id, $event)
                  "
                      />
                    </div>
                  </td>
                }
              </tr>
            } @empty {
              <tr>
                <td
                  [attr.colspan]="columns().length + 1"
                  class="px-4 py-8 text-center text-sm text-gray-500"
                >
                  No items available.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</lib-base-signal-input>
